import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { myTaskSettingsListName } from "src/api/config";
import Loading from "src/components/Loading";
import { MobileConfigureIcon } from "src/components/ui-icons/menu";

import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { useGetSelect } from "src/hooks/redux-selectors";
import { getItems } from "src/modules/spItems/actions";
import { selectCurrentUser } from "src/modules/users/selector";

import { FlexCol } from "src/utils/flexLayouts";
import TGButton from "./../../../../components/ui/TGButton";

export default function MTSettingsPage() {
  const { data: settings } = useGetSelect(myTaskSettingsListName);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const currentUser = useAppSelector(selectCurrentUser);

  if (!settings.length || !currentUser.email.length) {
    return <Loading />;
  }

  const userGroupIds = currentUser.groups.map((g: { Id: number }) => g.Id);
  const filteredSettings = settings.filter((setting) =>
    setting.UsersGroup ? setting.UsersGroup.some((obj) => userGroupIds.includes(obj.ID)) : false
  );

  return (
    <div>
      <div className="px-7.5 py-[26px] border-b border-[#DFE4EA]-500">
        <div className="flex items-center gap-2 hover:cursor-pointer w-fit">
          <span>
            <MobileConfigureIcon />
          </span>
          <span>Настройки</span>
        </div>
      </div>
      <div className="p-7.5">
        <div className="p-7.5 pt-5 bg-white rounded-md shadow-custom">
          <h3 className="mb-7.5 font-medium text-black">Мои задачи</h3>
          <FlexCol className="gap-[10px]">
            {filteredSettings.length > 0 ? (
              filteredSettings.map((setting) => (
                <a
                  className="flex px-5 py-[18px] gap-3 items-start rounded-lg border border-gray-300 bg-white"
                  target="_blank"
                  href={setting.Path}
                  key={setting.ID}
                  title={setting.Description}
                  rel="noreferrer"
                >
                  <img src={setting.IconUrl} className="w-6 h-6" alt="settingIcon" />
                  {setting.Title}
                </a>
              ))
            ) : (
              <>
                <div>У вас нет доступа к настройкам</div>
                <div className="flex space-x-2">
                  <TGButton onClick={() => navigate(-1)}>Вернуться назад</TGButton>
                  <TGButton
                    onClick={() =>
                      navigate("/dashboard/3", {
                        preventScrollReset: true,
                      })
                    }
                    color="bluedark"
                  >
                    Вернуться на главную
                  </TGButton>
                </div>
              </>
            )}
          </FlexCol>
        </div>
      </div>
    </div>
  );
}
